import type {
  WorkspaceSet,
  WorkspaceStateRecipe,
  WorkspaceStoreState,
  WorkspaceStoreSyncActions,
} from './workspace.type'

export const createWorkspaceActions = (set: WorkspaceSet): WorkspaceStoreSyncActions => ({
  clearError: () =>
    set((state) => {
      state.error = null
    }),
  clearScopedMemberData: () =>
    set((state) => {
      state.members = []
      state.notifications = []
      state.error = null
    }),
  finishRequest: () =>
    set((state) => {
      state.loading = false
    }),
  setRequestError: (error: unknown, fallbackMessage: string) =>
    set((state) => {
      state.error = error instanceof Error ? error.message : fallbackMessage
    }),
  setState: (patch: Partial<WorkspaceStoreState>) => set((state) => ({ ...state, ...patch })),
  startRequest: () =>
    set((state) => {
      state.loading = true
      state.error = null
    }),
  updateState: (recipe: WorkspaceStateRecipe) => set(recipe),
})
